import { action, makeObservable } from 'mobx';
import { RootStore } from './root';
import { AuthHandlers } from './emailStep';

export class SignupEmailStepStore implements AuthStore {
  public titleKey: string;
  public subtitleKey?: string;
  public showLoginEmailStep: boolean;
  public authHandlers: Partial<AuthHandlers> = {};
  constructor(private rootStore: RootStore) {
    const { displayStore } = rootStore;
    this.titleKey =
      displayStore.preset.signup?.title?.key ?? 'emailStep.signup.title';
    this.subtitleKey = displayStore.preset.signup?.subtitle?.key;
    makeObservable(this, {
      onShowSignupEmailStep: action,
    });
  }

  clear(): void {
    throw new Error('Method not implemented.');
  }

  onInitFields(): void {
    throw new Error('Method not implemented.');
  }

  presetSubtitleKey?: string | undefined;

  public onShowSignupEmailStep() {
    this.rootStore.emailStepStore.loginEmailStepStore.showLoginEmailStep =
      false;
  }
}
